import { render, staticRenderFns } from "./DocumentationViewer.vue?vue&type=template&id=54dfd1c2&scoped=true"
import script from "./DocumentationViewer.vue?vue&type=script&lang=js"
export * from "./DocumentationViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfd1c2",
  null
  
)

export default component.exports